import React from "react";
import { HubStatsWrapper, HubStatsBigTitle } from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import { useSelector } from "react-redux";
import { getHubStats } from "apps/BWW_PLAY_HUB/modules/selectors/hub_stats";
import styled from "styled-components";
import icon_rank from "apps/BWW_PLAY_HUB/assets/img/icon_rank.svg";


const RankInfo = styled.div`
	display: flex;
	align-items: center;
`;

const RankIcon = styled.img`
	margin-right: 20px;
	width: 54px;
	height: 62px;
	flex-shrink: 0;
`;

export const TopPercentsPP: React.FC = () => {
	const { pp } = useSelector(getHubStats);
	const { top_percent_on_leaderboard, top_rank_on_leaderboard } = pp;

	if (!top_rank_on_leaderboard) {
		return null;
	}

	return (
		<HubStatsWrapper bg={'#FEC600'}>
			<RankInfo>
				<RankIcon src={icon_rank} alt={'Rank'}/>
				<HubStatsBigTitle>Your current leaderboard rank of { top_rank_on_leaderboard } puts you
				in the { top_percent_on_leaderboard.toLowerCase() } of all P&P users this month</HubStatsBigTitle>
			</RankInfo>
		</HubStatsWrapper>
	);
};
